export default __webpack_public_path__ + "static/media/facebook (1).4d4fdd95.svg";